import React, { useMemo, useState, useEffect, useRef } from 'react';
import Markdown from '../chat/Markdown';
// @ts-ignore
import rawContent from './DOCUMENTACAO_NOS_FLUXO.md?raw';
import styles from './manual.module.css';
import LayoutUsuario from '@/components/navegacao/LayoutUsuario';
import { useHeadsObserver } from '@/hooks/useHeadsObserver';

interface TocItem {
    id: string;
    label: string;
    level: number; // 2 for category, 3 for node
}

export default function DialogoManualPage() {
    const contentRef = useRef<HTMLDivElement>(null);
    const { activeId } = useHeadsObserver(contentRef)

    useEffect(() => {
        console.log('Active ID:', activeId);
    }, [activeId]);

    const { content, toc } = useMemo(() => {
        const lines = (rawContent as string).split('\n');
        const newLines: string[] = [];
        const tocItems: TocItem[] = [];

        // Simple ID generator to avoid collisions
        const seenIds = new Set<string>();
        const getId = (label: string, prefix: string) => {
            let baseId = `${prefix}-${label.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`;
            if (baseId.endsWith('-')) baseId = baseId.slice(0, -1);
            let id = baseId;
            let count = 1;
            while (seenIds.has(id)) {
                id = `${baseId}-${count++}`;
            }
            seenIds.add(id);
            return id;
        };

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            if (line.startsWith('## ')) {
                const label = line.replace('## ', '').replace('Categoria: ', '').trim();
                const id = getId(label, 'cat');
                tocItems.push({ id, label, level: 2 });
                newLines.push(`<h2 id="${id}">${label}</h2>\n`);
            } else if (line.startsWith('### ')) {
                const label = line.replace('### ', '').trim();
                const id = getId(label, 'node');
                tocItems.push({ id, label, level: 3 });
                newLines.push(`<h3 id="${id}">${label}</h3>\n`);
            } else {
                newLines.push(line);
            }
        }

        return { content: newLines.join('\n'), toc: tocItems };
    }, []);

    const scrollTo = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };


    return (
        <LayoutUsuario>
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className={styles.markdownContent} ref={contentRef}>
                        <Markdown value={content} className="" allowIds={true} />
                    </div>
                </div>
                <div className={styles.menu}>
                    <h3 className={styles.categoryTitle} style={{ marginTop: 0 }}>Navegação</h3>
                    {toc.map((item, idx) => (
                        <div key={`${item.id}-${idx}`} style={{ marginLeft: item.level === 3 ? '0.75rem' : '0' }}>
                            {item.level === 2 ? (
                                <a
                                    onClick={() => scrollTo(item.id)}
                                    className={`${styles.categoryTitle} ${item.id === activeId ? styles.active : ''}`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {item.label}
                                </a>
                            ) : (
                                <a
                                    onClick={() => scrollTo(item.id)}
                                    className={`${styles.nodeLink} ${item.id === activeId ? styles.active : ''}`}
                                >
                                    {item.label}
                                </a>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </LayoutUsuario>
    );
}
